/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BackofficeSpendControlCreateRuleDtoV1 } from '../models';
// @ts-ignore
import type { BackofficeSpendControlPatchRuleDtoV1 } from '../models';
// @ts-ignore
import type { BackofficeSpendControlRuleDtoV1 } from '../models';
// @ts-ignore
import type { BackofficeSpendControlTestResultDtoV1 } from '../models';
// @ts-ignore
import type { BackofficeSpendControlTestRuleDtoV1 } from '../models';
// @ts-ignore
import type { CardCategoryBindingDtoV1 } from '../models';
// @ts-ignore
import type { CategoryDtoV1 } from '../models';
// @ts-ignore
import type { CreateCategoryDtoV1 } from '../models';
// @ts-ignore
import type { SetCategoryBindingDtoV1 } from '../models';
/**
 * SpendControlApi - axios parameter creator
 * @export
 */
export const SpendControlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCategoryDtoV1} createCategoryDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpendControlCategoryV1: async (createCategoryDtoV1: CreateCategoryDtoV1, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCategoryDtoV1' is not null or undefined
            assertParamExists('createSpendControlCategoryV1', 'createCategoryDtoV1', createCategoryDtoV1)
            const localVarPath = `/bo/v1/spend-control/categories/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCategoryDtoV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {BackofficeSpendControlCreateRuleDtoV1} backofficeSpendControlCreateRuleDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpendControlRuleV1: async (backofficeSpendControlCreateRuleDtoV1: BackofficeSpendControlCreateRuleDtoV1, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'backofficeSpendControlCreateRuleDtoV1' is not null or undefined
            assertParamExists('createSpendControlRuleV1', 'backofficeSpendControlCreateRuleDtoV1', backofficeSpendControlCreateRuleDtoV1)
            const localVarPath = `/bo/v1/spend-control/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backofficeSpendControlCreateRuleDtoV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryByCardIdV1: async (cardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('getCategoryByCardIdV1', 'cardId', cardId)
            const localVarPath = `/bo/v1/spend-control/categories/card/{card-id}/category-binding`
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpendControlCategoryV1: async (categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('getSpendControlCategoryV1', 'categoryId', categoryId)
            const localVarPath = `/bo/v1/spend-control/categories/{category-id}`
                .replace(`{${"category-id"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {any} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpendControlRuleV1: async (ruleId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('getSpendControlRuleV1', 'ruleId', ruleId)
            const localVarPath = `/bo/v1/spend-control/rules/{rule-id}`
                .replace(`{${"rule-id"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpendControlRulesV1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/v1/spend-control/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {any} ruleId 
         * @param {BackofficeSpendControlPatchRuleDtoV1} backofficeSpendControlPatchRuleDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSpendControlRuleV1: async (ruleId: any, backofficeSpendControlPatchRuleDtoV1: BackofficeSpendControlPatchRuleDtoV1, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('patchSpendControlRuleV1', 'ruleId', ruleId)
            // verify required parameter 'backofficeSpendControlPatchRuleDtoV1' is not null or undefined
            assertParamExists('patchSpendControlRuleV1', 'backofficeSpendControlPatchRuleDtoV1', backofficeSpendControlPatchRuleDtoV1)
            const localVarPath = `/bo/v1/spend-control/rules/{rule-id}`
                .replace(`{${"rule-id"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backofficeSpendControlPatchRuleDtoV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cardId 
         * @param {SetCategoryBindingDtoV1} setCategoryBindingDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSpendControlCategoryBindingV1: async (cardId: string, setCategoryBindingDtoV1: SetCategoryBindingDtoV1, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('setSpendControlCategoryBindingV1', 'cardId', cardId)
            // verify required parameter 'setCategoryBindingDtoV1' is not null or undefined
            assertParamExists('setSpendControlCategoryBindingV1', 'setCategoryBindingDtoV1', setCategoryBindingDtoV1)
            const localVarPath = `/bo/v1/spend-control/categories/card/{card-id}/category-binding`
                .replace(`{${"card-id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCategoryBindingDtoV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {any} ruleId 
         * @param {BackofficeSpendControlTestRuleDtoV1} backofficeSpendControlTestRuleDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSpendControlRuleV1: async (ruleId: any, backofficeSpendControlTestRuleDtoV1: BackofficeSpendControlTestRuleDtoV1, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('testSpendControlRuleV1', 'ruleId', ruleId)
            // verify required parameter 'backofficeSpendControlTestRuleDtoV1' is not null or undefined
            assertParamExists('testSpendControlRuleV1', 'backofficeSpendControlTestRuleDtoV1', backofficeSpendControlTestRuleDtoV1)
            const localVarPath = `/bo/v1/spend-control/rules/{rule-id}/test`
                .replace(`{${"rule-id"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backofficeSpendControlTestRuleDtoV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} categoryId 
         * @param {CreateCategoryDtoV1} createCategoryDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSpendControlCategoryV1: async (categoryId: string, createCategoryDtoV1: CreateCategoryDtoV1, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('updateSpendControlCategoryV1', 'categoryId', categoryId)
            // verify required parameter 'createCategoryDtoV1' is not null or undefined
            assertParamExists('updateSpendControlCategoryV1', 'createCategoryDtoV1', createCategoryDtoV1)
            const localVarPath = `/bo/v1/spend-control/categories/{category-id}`
                .replace(`{${"category-id"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCategoryDtoV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SpendControlApi - functional programming interface
 * @export
 */
export const SpendControlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SpendControlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateCategoryDtoV1} createCategoryDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSpendControlCategoryV1(createCategoryDtoV1: CreateCategoryDtoV1, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryDtoV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSpendControlCategoryV1(createCategoryDtoV1, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpendControlApi.createSpendControlCategoryV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {BackofficeSpendControlCreateRuleDtoV1} backofficeSpendControlCreateRuleDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSpendControlRuleV1(backofficeSpendControlCreateRuleDtoV1: BackofficeSpendControlCreateRuleDtoV1, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackofficeSpendControlRuleDtoV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSpendControlRuleV1(backofficeSpendControlCreateRuleDtoV1, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpendControlApi.createSpendControlRuleV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryByCardIdV1(cardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardCategoryBindingDtoV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryByCardIdV1(cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpendControlApi.getCategoryByCardIdV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpendControlCategoryV1(categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryDtoV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpendControlCategoryV1(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpendControlApi.getSpendControlCategoryV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {any} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpendControlRuleV1(ruleId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackofficeSpendControlRuleDtoV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpendControlRuleV1(ruleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpendControlApi.getSpendControlRuleV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpendControlRulesV1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackofficeSpendControlRuleDtoV1>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpendControlRulesV1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpendControlApi.getSpendControlRulesV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {any} ruleId 
         * @param {BackofficeSpendControlPatchRuleDtoV1} backofficeSpendControlPatchRuleDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchSpendControlRuleV1(ruleId: any, backofficeSpendControlPatchRuleDtoV1: BackofficeSpendControlPatchRuleDtoV1, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackofficeSpendControlRuleDtoV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchSpendControlRuleV1(ruleId, backofficeSpendControlPatchRuleDtoV1, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpendControlApi.patchSpendControlRuleV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cardId 
         * @param {SetCategoryBindingDtoV1} setCategoryBindingDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSpendControlCategoryBindingV1(cardId: string, setCategoryBindingDtoV1: SetCategoryBindingDtoV1, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setSpendControlCategoryBindingV1(cardId, setCategoryBindingDtoV1, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpendControlApi.setSpendControlCategoryBindingV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {any} ruleId 
         * @param {BackofficeSpendControlTestRuleDtoV1} backofficeSpendControlTestRuleDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testSpendControlRuleV1(ruleId: any, backofficeSpendControlTestRuleDtoV1: BackofficeSpendControlTestRuleDtoV1, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackofficeSpendControlTestResultDtoV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testSpendControlRuleV1(ruleId, backofficeSpendControlTestRuleDtoV1, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpendControlApi.testSpendControlRuleV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} categoryId 
         * @param {CreateCategoryDtoV1} createCategoryDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSpendControlCategoryV1(categoryId: string, createCategoryDtoV1: CreateCategoryDtoV1, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryDtoV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSpendControlCategoryV1(categoryId, createCategoryDtoV1, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpendControlApi.updateSpendControlCategoryV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SpendControlApi - factory interface
 * @export
 */
export const SpendControlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SpendControlApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateCategoryDtoV1} createCategoryDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpendControlCategoryV1(createCategoryDtoV1: CreateCategoryDtoV1, options?: RawAxiosRequestConfig): AxiosPromise<CategoryDtoV1> {
            return localVarFp.createSpendControlCategoryV1(createCategoryDtoV1, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {BackofficeSpendControlCreateRuleDtoV1} backofficeSpendControlCreateRuleDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpendControlRuleV1(backofficeSpendControlCreateRuleDtoV1: BackofficeSpendControlCreateRuleDtoV1, options?: RawAxiosRequestConfig): AxiosPromise<BackofficeSpendControlRuleDtoV1> {
            return localVarFp.createSpendControlRuleV1(backofficeSpendControlCreateRuleDtoV1, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryByCardIdV1(cardId: string, options?: RawAxiosRequestConfig): AxiosPromise<CardCategoryBindingDtoV1> {
            return localVarFp.getCategoryByCardIdV1(cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpendControlCategoryV1(categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<CategoryDtoV1> {
            return localVarFp.getSpendControlCategoryV1(categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {any} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpendControlRuleV1(ruleId: any, options?: RawAxiosRequestConfig): AxiosPromise<BackofficeSpendControlRuleDtoV1> {
            return localVarFp.getSpendControlRuleV1(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpendControlRulesV1(options?: RawAxiosRequestConfig): AxiosPromise<Array<BackofficeSpendControlRuleDtoV1>> {
            return localVarFp.getSpendControlRulesV1(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {any} ruleId 
         * @param {BackofficeSpendControlPatchRuleDtoV1} backofficeSpendControlPatchRuleDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSpendControlRuleV1(ruleId: any, backofficeSpendControlPatchRuleDtoV1: BackofficeSpendControlPatchRuleDtoV1, options?: RawAxiosRequestConfig): AxiosPromise<BackofficeSpendControlRuleDtoV1> {
            return localVarFp.patchSpendControlRuleV1(ruleId, backofficeSpendControlPatchRuleDtoV1, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cardId 
         * @param {SetCategoryBindingDtoV1} setCategoryBindingDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSpendControlCategoryBindingV1(cardId: string, setCategoryBindingDtoV1: SetCategoryBindingDtoV1, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setSpendControlCategoryBindingV1(cardId, setCategoryBindingDtoV1, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {any} ruleId 
         * @param {BackofficeSpendControlTestRuleDtoV1} backofficeSpendControlTestRuleDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSpendControlRuleV1(ruleId: any, backofficeSpendControlTestRuleDtoV1: BackofficeSpendControlTestRuleDtoV1, options?: RawAxiosRequestConfig): AxiosPromise<BackofficeSpendControlTestResultDtoV1> {
            return localVarFp.testSpendControlRuleV1(ruleId, backofficeSpendControlTestRuleDtoV1, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} categoryId 
         * @param {CreateCategoryDtoV1} createCategoryDtoV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSpendControlCategoryV1(categoryId: string, createCategoryDtoV1: CreateCategoryDtoV1, options?: RawAxiosRequestConfig): AxiosPromise<CategoryDtoV1> {
            return localVarFp.updateSpendControlCategoryV1(categoryId, createCategoryDtoV1, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SpendControlApi - object-oriented interface
 * @export
 * @class SpendControlApi
 * @extends {BaseAPI}
 */
export class SpendControlApi extends BaseAPI {
    /**
     * 
     * @param {CreateCategoryDtoV1} createCategoryDtoV1 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpendControlApi
     */
    public createSpendControlCategoryV1(createCategoryDtoV1: CreateCategoryDtoV1, options?: RawAxiosRequestConfig) {
        return SpendControlApiFp(this.configuration).createSpendControlCategoryV1(createCategoryDtoV1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {BackofficeSpendControlCreateRuleDtoV1} backofficeSpendControlCreateRuleDtoV1 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpendControlApi
     */
    public createSpendControlRuleV1(backofficeSpendControlCreateRuleDtoV1: BackofficeSpendControlCreateRuleDtoV1, options?: RawAxiosRequestConfig) {
        return SpendControlApiFp(this.configuration).createSpendControlRuleV1(backofficeSpendControlCreateRuleDtoV1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpendControlApi
     */
    public getCategoryByCardIdV1(cardId: string, options?: RawAxiosRequestConfig) {
        return SpendControlApiFp(this.configuration).getCategoryByCardIdV1(cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpendControlApi
     */
    public getSpendControlCategoryV1(categoryId: string, options?: RawAxiosRequestConfig) {
        return SpendControlApiFp(this.configuration).getSpendControlCategoryV1(categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {any} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpendControlApi
     */
    public getSpendControlRuleV1(ruleId: any, options?: RawAxiosRequestConfig) {
        return SpendControlApiFp(this.configuration).getSpendControlRuleV1(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpendControlApi
     */
    public getSpendControlRulesV1(options?: RawAxiosRequestConfig) {
        return SpendControlApiFp(this.configuration).getSpendControlRulesV1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {any} ruleId 
     * @param {BackofficeSpendControlPatchRuleDtoV1} backofficeSpendControlPatchRuleDtoV1 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpendControlApi
     */
    public patchSpendControlRuleV1(ruleId: any, backofficeSpendControlPatchRuleDtoV1: BackofficeSpendControlPatchRuleDtoV1, options?: RawAxiosRequestConfig) {
        return SpendControlApiFp(this.configuration).patchSpendControlRuleV1(ruleId, backofficeSpendControlPatchRuleDtoV1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cardId 
     * @param {SetCategoryBindingDtoV1} setCategoryBindingDtoV1 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpendControlApi
     */
    public setSpendControlCategoryBindingV1(cardId: string, setCategoryBindingDtoV1: SetCategoryBindingDtoV1, options?: RawAxiosRequestConfig) {
        return SpendControlApiFp(this.configuration).setSpendControlCategoryBindingV1(cardId, setCategoryBindingDtoV1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {any} ruleId 
     * @param {BackofficeSpendControlTestRuleDtoV1} backofficeSpendControlTestRuleDtoV1 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpendControlApi
     */
    public testSpendControlRuleV1(ruleId: any, backofficeSpendControlTestRuleDtoV1: BackofficeSpendControlTestRuleDtoV1, options?: RawAxiosRequestConfig) {
        return SpendControlApiFp(this.configuration).testSpendControlRuleV1(ruleId, backofficeSpendControlTestRuleDtoV1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} categoryId 
     * @param {CreateCategoryDtoV1} createCategoryDtoV1 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpendControlApi
     */
    public updateSpendControlCategoryV1(categoryId: string, createCategoryDtoV1: CreateCategoryDtoV1, options?: RawAxiosRequestConfig) {
        return SpendControlApiFp(this.configuration).updateSpendControlCategoryV1(categoryId, createCategoryDtoV1, options).then((request) => request(this.axios, this.basePath));
    }
}

